import { render, staticRenderFns } from "./information.vue?vue&type=template&id=44df8fad&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"
import style0 from "./information.vue?vue&type=style&index=0&id=44df8fad&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44df8fad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44df8fad')) {
      api.createRecord('44df8fad', component.options)
    } else {
      api.reload('44df8fad', component.options)
    }
    module.hot.accept("./information.vue?vue&type=template&id=44df8fad&scoped=true", function () {
      api.rerender('44df8fad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/additionalFrom/information.vue"
export default component.exports